import { KendoBaseComponent, KendoSharedMethods } from '@progress/kendo-base-components-vue-wrapper'
import MenuProps from './MenuProps'

import OpenOnClick from './OpenOnClick'
import Animation from '../Common/Animation'
import Scrollable from '../Common/Scrollable'

export default {
    template: '<ul><slot></slot></ul>',
    props: MenuProps,
    mixins: [
        KendoBaseComponent,
        KendoSharedMethods,
        Animation,
        OpenOnClick,
        Scrollable
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoMenu(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMenu()
        },
        _resolveChildren() {
            if(this.$options.propsData && !this.$options.propsData['dataSource'] && this.$slots.default){
                var items = this.resolveInnerTags('kendo-menu-item')

                if(items.length) {
                    this.widgetOptions['dataSource'] = items
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoMenu/KendoMenuMixin.js